// orderAbout

export default [
  // orderAbout
  {
    path: '/ObjectSelect',
    name: 'placeOrder',
    component: () =>
    import(/* webpackChunkName: "orderAbout" */ '@/components/order-about/PlaceOrder')
  },
  // 中间页面
  {
    path: '/OrderCreate/:id',
    name: 'OrderCreate',
    component: () =>
      import(/* webpackChunkName: "orderAbout" */ '@/components/order-about/OrderCreate')
  },
  {
    path: '/confirmOrder',
    name: 'confirmOrder',
    meta: {
      goBack: '/taskList'
    },
    component: () =>
    import(/* webpackChunkName: "orderAbout" */ '@/components/order-about/ConfirmOrder')
  },
  {
    path: '/paySucceed',
    name: 'paySucceed',
    component: () =>
    import(/* webpackChunkName: "orderAbout" */ '@/components/order-about/PaySucceed')
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () =>
    import(/* webpackChunkName: "orderAbout" */ '@/components/order-about/OrderDetail')
  },
  {
    path: '/orderRefund',
    name: 'orderRefund',
    component: () =>
    import(/* webpackChunkName: "orderAbout" */ '@/components/order-about/OrderRefund')
  },
  {
    path: '/specialOrderRefund',
    name: 'specialOrderRefund',
    component: () =>
    import(/* webpackChunkName: "orderAbout" */ '@/components/order-about/SpecialRefund')
  },
  {
    path: '/entryRequirements',
    name: 'EntryRequirements',
    component: () =>
    import(/* webpackChunkName: "orderAbout" */ '@/components/order-about/EntryRequirements')
  },
  {
    path: '/applyInvoice/:taskRelationId/:orderId',
    name: 'ApplyInvoice',
    component: () =>
    import(/* webpackChunkName: "orderAbout" */ '@/components/order-about/ApplyInvoice')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/orderAbout.js